import { useRouter } from '@tanstack/react-router'
import { buildV3Url } from '~/utils/legacy'

export const useSafeNavigateToLinkFromLegacy = () => {
  const router = useRouter()

  return (path: string) => {
    if (window.JobConfig) {
      document.location.href = buildV3Url(path)
      return
    }

    if (router) {
      router.history.push(path)
    }
  }
}
